import { Component, Host, h, Prop } from '@stencil/core';
import { metrics } from '../../utils';
import type {
  Alpha,
  HtmlTags,
  TypographyFamilies,
  TypographyFamiliesDisplaySizes,
  TypographyFamiliesHeadlineSizes,
  TypographyFamiliesBodySizes,
  TypographyTextStyles,
} from '../../utils/types/index';

/**
 *  @cssprop --prism-text-word-spacing - Spacing between words
 *  @cssprop --prism-text-line-height - Spacing between text lines
 *  @cssprop --prism-text-spacing-padding - Padding around text
 *  @cssprop --prism-text-spacing-margin - Margin around text
 *  @cssprop --prism-text-max-width - Maximum width of text
 *  @cssprop --prism-text-display - Display property of text
 *  @cssprop --prism-text-priority - Text Priority
 *  @slot - Default Text Content
 */
@Component({
  tag: 'prism-text',
  styleUrl: 'prism-text.css',
  shadow: true,
})
export class Text {
  /** HTML Tag to Render */
  @Prop() tag: HtmlTags = 'p';
  /** Text Families */
  @Prop() family: TypographyFamilies = 'body';
  /** Text Size, Numeric for Display Family */
  @Prop() size?: TypographyFamiliesDisplaySizes | TypographyFamiliesHeadlineSizes | TypographyFamiliesBodySizes = '300';
  /** As a specialized text style, used in other components */
  @Prop() as?: TypographyTextStyles;
  /** Apply [...] to the content */
  @Prop() ellipsis: boolean = false;
  /** Text Priority: Alpha */
  @Prop() priority: Alpha = 'primary';
  /** Expressive: Adds a gradient (if available) to the text */
  @Prop() expressive?: boolean = false;
  connectedCallback() {
    // Component Data Layer
    metrics('prism-text');
  }
  render() {
    const CustomTag = this.tag;
    return (
      <Host class={{ ['text-block']: this.tag !== 'span' }}>
        <CustomTag
          class={{
            [`${this.family}-${this.size}`]: this.as === undefined,
            [`${this.as}`]: this.as !== undefined,
            text: true,
            [this.priority]: true,
            ellipsis: this.ellipsis,
            expressive: this.expressive,
          }}
        >
          <slot></slot>
        </CustomTag>
      </Host>
    );
  }
}
